import { makeAutoObservable, onBecomeObserved } from "mobx"

import { convertsApi } from "@src/shared/api"
import {
  ConvertPairsResponse,
  ConvertPairsResponseFrom,
  ConvertResponse,
  ConvertTokenResponse,
} from "@src/shared/api/generated"

class ConvertStore {
  convertData: ConvertResponse = {} as ConvertResponse

  convertRate?: ConvertTokenResponse

  getConvertRate = async (
    from: ConvertPairsResponseFrom,
    to: ConvertPairsResponseFrom,
    amount: string,
  ): Promise<any> => {
    const networkFrom = from.network!

    const symbolFrom = from.symbol!

    const networkTo = to.network!

    const symbolTo = to.symbol!

    try {
      this.isLoading = true

      const { data: result } = await convertsApi.getConvertToken(
        networkFrom,
        symbolFrom,
        networkTo,
        symbolTo,
        amount,
      )

      if (result.success) {
        this.convertRate = result.data

        return this.convertRate
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false
    }
  }

  getPairs = async () => {
    try {
      this.isLoading = true

      const { data: result } = await convertsApi.getConvertsPairs()

      if (result.success) {
        this.pairs = result.data
      }
    } catch (catchErrors) {
    } finally {
      this.isLoading = false
    }
  }

  isLoading = false

  pairs?: ConvertPairsResponse[] = []

  resetConvertRate = () => (this.convertRate = undefined)

  sendConvertRequest = async (): Promise<any> => {
    try {
      this.isLoading = true

      const { data: result } = await convertsApi.scheduleToConvert({
        token: this.convertRate?.token,
      })

      if (result.success) {
        this.convertData = result.data as ConvertResponse

        return this.convertData
      }
    } finally {
      this.isLoading = false
    }
  }

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "pairs", this.getPairs)
  }
}

export const convertStore = new ConvertStore()
